import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scrollTo(event) {
    event.preventDefault()
    const id = event.target.href.split("#")[1]
    document.getElementById(id).scrollIntoView({ behavior: "smooth" })
  }
}
